const $ = require('jquery');
window.$ = $;
global.$ = global.jQuery = $;
const moment = require('moment');
global.moment = moment;
const dt = require('datatables.net-bs4');
global.dt = dt;

import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import solid from '@fortawesome/fontawesome-pro-solid';
//import faCloudUploadAlt from '@fortawesome/fontawesome-pro-solid/faCloudUploadAlt';
//import faExclamationCircle from '@fortawesome/fontawesome-pro-solid/faExclamationCircle';

fontawesome.library.add(light,solid/*faCloudUploadAlt,faExclamationCircle*/);


require('datatables.net-select-dt');
require('bootstrap');
require('air-datepicker');
require('../../node_modules/air-datepicker/dist/js/i18n/datepicker.fr.js');
//require('bootstrap');

import {CallFunction} from '../../public/bundles/w3comhulk/callFunction.js';
global.CallFunction = CallFunction;
import {apiRequest, updateSap, updateSapLine, reloadDisplayForm} from '../../public/bundles/w3comhulk/ajax.js';
global.apiRequest = apiRequest;
global.updateSap = updateSap;
global.updateSapLine = updateSapLine;
global.reloadDisplayForm = reloadDisplayForm;
import {countSelectedRows, goToLine, openForm} from '../../public/bundles/w3comhulk/utils.js';
global.countSelectedRows = countSelectedRows;
global.goToLine = goToLine;
global.openForm = openForm;
// END HULK
import {updateServiceCall,launchUpdateServiceCall,launchOneUpdateServiceCall} from './display_service_call';
global.updateServiceCall = updateServiceCall;
global.launchUpdateServiceCall = launchUpdateServiceCall;
global.launchOneUpdateServiceCall = launchOneUpdateServiceCall;

$('#passwordRadio').click(function(){
    $('#largeTextRadio').prop('checked',false);
    $('#passwordInput').css('display','block');
    $('#zoneInput').css('display','none');
    $('#zoneInput').val('')
})

$('#largeTextRadio').click(function(){
    $('#passwordRadio').prop('checked',false);
    $('#passwordInput').css('display','none');
    $('#zoneInput').css('display','block');
    $('#passwordInput').val('')
})

$('#passwordSharingButton').click(function(){
    $.post(
        '/password-process',
        {
            passwordInput: $('#passwordInput').val(),
            zoneInput: $('#zoneInput').val()
        },
        function(data){
            var html = '';
            if(data['valid']){
                html += '<div class="form-group mt-2">' +
                    '<label for="public-link-data" style="font-size: 1rem">Lien public</label>' +
                    '<div class="input-group">' +
                    '<input type="text" class="form-control" value="' + data['public-link'] + '" id="public-link-data">' +
                    '  <div class="input-group-append">' +
                    '    <button class="btn btn-success copy-clipboard" id="public-link" onclick="copyToClipboard(\'public-link-data\')"><i class="fal fa-copy"></i></button>' +
                    '  </div>' +
                    '</div></div>';

                html += '<div class="form-group mt-2">' +
                    '<label for="public-link-data" style="font-size: 1rem">Lien de suivi (à ne pas transmettre au destinataire)</label>' +
                    '<div class="input-group">' +
                    '<input type="text" class="form-control" value="' + data['private-link'] + '" id="private-link-data">' +
                    '  <div class="input-group-append">' +
                    '    <button class="btn btn-success copy-clipboard" id="private-link" onclick="copyToClipboard(\'private-link-data\')"><i class="fal fa-copy"></i></button>' +
                    '  </div>' +
                    '</div></div>';

                $('#searchResultContainer').html(html);

                $('#passwordInput').addClass('disappear');
                $('#zoneInput').addClass('disappear');
            }
        });
});

$('#requestLinkButton').click(function(){

   $.post(
       '/request-link-process',
       {'email':$('#email').val()},
       function (data){
           var html = '';
           if(data['valid']){
               html += '<div class="form-group mt-2">' +
                   '<label for="public-link-data" style="font-size: 0.8rem;color: #6c757d">Lien à transmettre au client</label>' +
                   '<div class="input-group">' +
                   '<input type="text" class="form-control" value="' + data['public-link'] + '" id="public-link-data">' +
                   '  <div class="input-group-append">' +
                   '    <button class="btn btn-success copy-clipboard" id="public-link" onclick="copyToClipboard(\'public-link-data\')"><i class="fal fa-copy"></i></button>' +
                   '  </div>' +
                   '</div></div>';

               html += '<div class="form-group mt-2">' +
                   '<label for="public-link-data" style="font-size: 0.8rem;color: #6c757d">Lien de visualisation du mot de passe client</label>' +
                   '<div class="input-group">' +
                   '<a href="' + data['private-link'] + '" class="btn btn-success btn-block">Voir le mot de passe transmis</a>' +
                   '</div></div>';

               $('#searchResultContainer').html(html);
           }
       }
   )
});

$('#shareLinkButton').click(function(){
    $('#textInput').addClass('disappear');
    $.post(
        '/share-link-process',
        {
            textInput: $('#textInput').val(),
            shareLinkToken: $('#shareLinkToken').val()
        },
        function(data){
            console.log(data);
            var html = '';
            if(data['valid']){
                html = '<div class="alert alert-success mt-2">Votre mot de passe a été transmis avec succès.</div>';
            } else {
                html = '<div class="alert alert-danger mt-2">' + data['message'] + '</div>';
            }

            $('#searchResultContainer').html(html);
        }
    )
});

$('#requestPasswordButton').click(function(){
    $.get(
        '/request-password-process',
        function (data){
            var html = '';
            if(data['valid']){
                html += '<div class="form-group mt-2">' +
                    '<label for="public-link-data" style="font-size: 0.8rem;color: #6c757d">Lien à transmettre au client</label>' +
                    '<div class="input-group">' +
                    '<input type="text" class="form-control" value="' + data['public-link'] + '" id="public-link-data">' +
                    '  <div class="input-group-append">' +
                    '    <button class="btn btn-success copy-clipboard" id="public-link" onclick="copyToClipboard(\'public-link-data\')"><i class="fal fa-copy"></i></button>' +
                    '  </div>' +
                    '</div></div>';

                $('#searchResultContainer').html(html);
            }
        });
});

global.copyToClipboard = function(id) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($('#' + id).val()).select();
    var retVal = document.execCommand("copy");
    $temp.remove();
};

global.readFromServer = function(token) {
    $('#bouton-visualisation').addClass('d-none');
    $.get(
        '/password-read/' + token,
        function(data){
            if(data.status === 'success'){
                $('#information').removeClass('d-none');
                if(data.clearedPassword !== ''){
                    $('#bloc-clear-password').removeClass('d-none');
                    $('#public-password-data-copy').val(data.clearedPassword);
                    $('#public-password-data-copy').addClass('appear');
                }
                if(data.clearedLargeText !== ''){
                    $('#bloc-large-text').removeClass('d-none');
                    $('#public-large-text-data-copy').text(data.clearedLargeText)
                    $('#public-large-text-data-copy').addClass('appear')
                }

            }
        }
    )
}

global.copyClipBoard = function(idElement) {
    try {
        console.log(idElement);
        var body = $("body")[0];
        $('.body').append('<textarea id="tempClipBoard" ></textarea>');
        $('#tempClipBoard').val($('#'+idElement).val());
        $('#tempClipBoard').select();
        var retVal = document.execCommand("copy");
        $('#tempClipBoard').remove();
        $('#'+idElement+'Action').html('Copied');
        $('#'+idElement+'Action').css('color','#00FF00');
    } catch (err) {
        $('#'+idElement+'Action').val('Error');
    }
};

if($('#batchRequestModal').length > 0){
    $('#batchRequestModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget) // Button that triggered the modal
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this)
        modal.find('.modal-title').text('Aide contextuelle')

        let method = $('#batch_method').val();
        let format = $('#batch_format').val();
        let helpContent = '<div class="alert alert-w3com"><i class="fas fa-exclamation-circle mr-2"></i>Ce module ne contrôle pas l\'existence du endpoint, ni l\'intégrité des données</div>';
        if(['PATCH','DELETE','CANCEL','CLOSE'].includes(method)){
            helpContent += '<h3><i class="fas fa-chevron-right mr-2" style="color: #00ff00"></i> Endpoint</h3>' +
                '<p>Indiquer le endpoint avec les noms de champs utilisés par le Service Layer en ajoutant des \' si nécessaire</p>' +
                '<figure class="bg-light p-2"><pre style="margin-bottom: 0">BusinessPartners(\'CardCode\')' + "\n" + 'Invoices(DocEntry)</pre></figure>';
        }
        if(['DELETE','CANCEL','CLOSE'].includes(method)){
            helpContent += '<p>Les données doivent contenir au moins la colonne servant de clé primaire pour le endpoint. ' +
                'Par exemple CardCode pour BusinessPartners ou DocEntry pour Invoices.<br />Les autres colonnes seront ignorées.</p>';
        }

        if(format === 'JSON'){
            helpContent += "<h3><i class=\"fas fa-chevron-right mr-2\" style=\"color: #00ff00\"></i> Data</h3>" +
                "<p>Renseigner les données sous la forme d'un tableau JSON</p>" +
                "<figure class=\"bg-light p-2\"><pre style='margin-bottom:0'>[\n" +
                "\t{\"CardCode\": \"C00001\",\"CardName\":\"ACME 01\"},\n" +
                "\t{\"CardCode\": \"C00002\",\"CardName\":\"ACME 02\"}\n" +
                "]</pre></figure>"
        } else {
            helpContent += "<h3><i class=\"fas fa-chevron-right mr-2\" style=\"color: #00ff00\"></i> Data</h3>" +
                "<p>Copier directement les cellules dans Excel et coller le contenu. Il doit être en séparateur tabulation normalement.</p>" +
                "<figure class=\"bg-light p-2\"><pre style='margin-bottom:0'>CardCode\tCardName\n" +
                "C00001\tACME 01\n" +
                "C00002\tACME 02</pre></figure>"
        }

        modal.find('.modal-body').html(helpContent);
    })
}

if($('#batchResponseModal').length > 0){
    $('#batchResponseModal').on('show.bs.modal', function (event) {
        var modal = $(this)
        modal.find('.modal-title').text('Aide contextuelle')

        let helpContent = '<h3><i class="fas fa-chevron-right mr-2" style="color: #00ff00"></i> Onglet Headers</h3>' +
            '<img src="/images/postman-header.png" alt="postman-header" style="width: 750px;" />' +
            '<p style="padding-left: 10px;"><span style="color: red;font-size: 18px;">1</span> - Copier / coller le Enpoint en ajoutant l\'url du serveur et le port en 50000</p>' +
            '<p style="padding-left: 10px;"><span style="color: red;font-size: 18px;">2</span> - Copier / coller le Content-Type dans l\'onglet <b>Headers</b></p><br />';

        helpContent += '<h3><i class="fas fa-chevron-right mr-2" style="color: #00ff00"></i> Onglet Body</h3>' +
            '<img src="/images/postman-body.png" alt="postman-body" style="width: 750px;" />' +
            '<p style="padding-left: 10px;"><span style="color: red;font-size: 18px;">3</span> - Copier / coller le champ <b>Data</b> dans le champ Body en mode <b>raw</b></p>';

            modal.find('.modal-body').html(helpContent);
    });
}



// WEBPACK FOOTER //
// ./assets/js/app.js